import { render, staticRenderFns } from "./addProduct.vue?vue&type=template&id=26c83010&scoped=true&"
import script from "./addProduct.vue?vue&type=script&lang=js&"
export * from "./addProduct.vue?vue&type=script&lang=js&"
import style0 from "./addProduct.vue?vue&type=style&index=0&id=26c83010&prod&scoped=true&lang=less&"
import style1 from "./addProduct.vue?vue&type=style&index=1&id=26c83010&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c83010",
  null
  
)

export default component.exports